<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import SalesDetailFactList from './SalesDetailFactList.vue';

const props = defineProps({
  party: { type: Object, required: true },
  summary: { type: Boolean, default: false },
  cardTitle: { type: String, default: '' },
});
const { t } = useI18n();
const identity = computed(() => props.party.profile?.identity || {});
const detailItems = computed(() => [
  {
    key: 'cnpj',
    label: t('SALES_PARTIES.FORM.CNPJ'),
    value: identity.value.cnpj,
  },
  {
    key: 'legal-name',
    label: t('SALES_PARTIES.FORM.LEGAL_NAME'),
    value: identity.value.legal_name,
  },
  {
    key: 'trade-name',
    label: t('SALES_PARTIES.FORM.TRADE_NAME'),
    value: identity.value.trade_name,
  },
  {
    key: 'phone',
    label: t('SALES_PARTIES.FORM.PHONE'),
    value: identity.value.phone,
  },
]);
const summaryItems = computed(() => [
  {
    key: 'cnpj',
    label: t('SALES_PARTIES.FORM.CNPJ'),
    value: identity.value.cnpj,
  },
  {
    key: 'phone',
    label: t('SALES_PARTIES.SUMMARY.PHONE'),
    value: identity.value.phone,
  },
  {
    key: 'legal-name',
    label: t('SALES_PARTIES.FORM.LEGAL_NAME'),
    value: identity.value.legal_name,
  },
  {
    key: 'trade-name',
    label: t('SALES_PARTIES.FORM.TRADE_NAME'),
    value: identity.value.trade_name,
  },
]);
const items = computed(() =>
  props.summary ? summaryItems.value : detailItems.value
);
const title = computed(
  () => props.cardTitle || t('SALES_PARTIES.COMPANY.TITLE')
);
</script>

<template>
  <LaisCard :title="title" prefix-icon="i-lucide-building-2">
    <div class="grid gap-4">
      <div v-if="!summary" class="flex flex-wrap gap-2">
        <span
          class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-muted"
        >
          {{ t('SALES.DETAIL.PERSON_KIND.COMPANY') }}
        </span>
        <span
          class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-muted"
        >
          {{ t('SALES_PARTIES.COMMON.COMPANY') }}
        </span>
      </div>
      <SalesDetailFactList :items="items" />
    </div>
  </LaisCard>
</template>
